import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateDocumentType($companyId: ID!, $id: ID!, $attributes: DocumentTypeAttributes!) {
    updateDocumentType(companyId: $companyId, id: $id, attributes: $attributes) {
      documentType {
        id
        ...UpdatedDocumentType
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedDocumentType on DocumentType {
    id
    name
    dateDue
    dateIssued
    freeagentResource
    xeroResource
    incrementStart
    incremental
    nextNumber
    subject
    crewVisible
    size
    orientation
    documentTypeBlocks { id }
    preview { url }
  }
`
